<template>

  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card>
            <div slot="header"><i class='fa fa-align-justify'></i> 面单统计</div>

            <b-form-group label="" label-for="elementsAppendButton">
              <b-input-group>
                <b-form-input v-model="options.query.userName" placeholder="用户名"></b-form-input>&nbsp;&nbsp;&nbsp;
<!--                <b-form-input v-model="options.query.trackingNo" placeholder="顺丰单号"></b-form-input>&nbsp;&nbsp;-->
                <b-form-textarea
                  id="textarea"
                  v-model="options.query.trackingNo"
                  placeholder="请输入顺丰单号，多个顺丰单号请用换行符或逗号隔开"
                  rows="2"
                ></b-form-textarea>&nbsp;&nbsp;

                <b-form-textarea
                  id="textarea"
                  v-model="options.query.agentMailno"
                  placeholder="请输入代理单号，多个代理单号请用换行符或逗号隔开"
                  rows="2"
                ></b-form-textarea>&nbsp;&nbsp;

                <b-form-textarea
                  id="textarea"
                  v-model="options.query.directionCode"
                  placeholder="请输入流向代码，多个流向代码请用换行符或逗号隔开"
                  rows="2"
                ></b-form-textarea>&nbsp;&nbsp;
<!--                <b-form-input v-model="options.query.directionCode" placeholder="流向代码"></b-form-input>&nbsp;&nbsp;-->
                <b-form-input type="date" v-model="options.query.beginTime"></b-form-input>&nbsp;&nbsp;&nbsp;
                <b-form-input type="date" v-model="options.query.endTime"></b-form-input>&nbsp;&nbsp;&nbsp;
                <b-input-group-append>
                  <b-button variant="primary" squared  size = "sm" @click="clickSearch()"><i class="fa fa-search"></i></b-button>&nbsp;
                  &nbsp;
                  <b-button variant="primary" type="submit" size="sm" @click="clickExport(options)"><i class="fa fa-dot-circle-o"></i> 下载</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <v-server-table ref="table" :url="backendUrl + '/label/statistics/get'" :columns="columns" :options="options" @error="errorLoadingTableData">

            </v-server-table>

          </b-card>
        </b-col>
      </b-row>
    </div>

  </div>


</template>

<script>
  import axios from 'axios'
  import { Switch as cSwitch } from '@coreui/vue'
  import { validationMixin } from 'vuelidate'

  export default {
    mixins: [validationMixin],
    components: {
      cSwitch
    },
    data () {
      return {
        backendUrl: axios.backendUrl,
        columns: ['id', 'userName', 'trackingNo', 'agentMailno','dCountry','directionCode', 'subCarrierNo', 'expressType', 'agentCode', 'labelVersion','source','createTime'],
        options: {
          query:{
            userName: '',
            trackingNo: '',
            agentMailno:'',
            directionCode: '',
            beginTime: '',
            endTime: ''
          },
          requestAdapter(data) {
            data.userName = this.query.userName
            data.trackingNo = this.query.trackingNo
            data.agentMailno = this.query.agentMailno
            data.directionCode = this.query.directionCode
            data.beginTime = this.query.beginTime
            data.endTime = this.query.endTime
            return data
          },
          filterable: false,
          perPage: 10,
          perPageValues: [10],
          headings: {
            id:'序号',
            userName: '用户名',
            trackingNo: '顺丰单号',
            agentMailno: '代理单号',
            dCountry: '目的国',
            directionCode: '流向代码',
            subCarrierNo: '转单号',
            expressType: '产品类型',
            agentCode: '代理',
            labelVersion: '面单版本号',
            source: '来源',
            createTime: '访问时间'
          }
        },
        fields: [],
        errorTitle: null,
        errorMessage: null,
        form: {
          userName: null,
          trackingNo: null,
          agentMailno: null,
          directionCode: null,
          beginTime: null,
          endTime: null
        },
      }
    },
    validations: {

    },
    methods: {
      showError(error) {
        if (error.response) {
          this.errorTitle = error.response.data.error
          this.errorMessage = error.response.data.message
          this.errorModal = true
        } else {
          this.errorTitle = error.message
          this.errorMessage = '无法访问后端'
          this.errorModal = true
        }
      },
      errorLoadingTableData(error) {
        this.showError(error)
      },
      clickSearch() {
        this.$refs.table.refresh()
      },
      clickExport(options) {
        window.location.href=this.backendUrl +"/label/statistics/export?userName="+options.query.userName+"&trackingNo=" + options.query.trackingNo +"&agentMailno=" + options.query.agentMailno+ "&directionCode="+options.query.directionCode+"&beginTime="+options.query.beginTime+"&endTime="+options.query.endTime;
      }

    }
  }
</script>

<style>
  th, td:nth-child(odd), td:nth-child(even) {
    white-space: nowrap;
    text-align: center;
    vertical-align: middle;
  }
</style>
